"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleNamespace = void 0;
// TODO(#323): remove on v6, move to ./dom/types.ts
exports.StyleNamespace = 'dg'; // Decentraland Gatsby
